<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import Link from "svelte-link";
    import { Badge, Button, Col } from "sveltestrap";
    import { href, Navigation } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import {navigationData} from "../../../Data/FAQ/FAQ"
</script>
<Col lg="12">
  <Card cardProps="card-mb-faq" cardHeaderprops="faq-header" cardBodyprops="faq-body">
    <div slot="customheader">
      <h5 class="ps-0">{Navigation}</h5>
      <FeatherIcon icon="settings"/>  
    </div>
    <div slot="contentbody">
      <div class="navigation-btn">
          <Button color="primary" href={href}>
            <FeatherIcon class="m-r-10" icon="message-square"/>{'Ask Question'}
          </Button>
      </div>
      <div class="navigation-option">
        <ul>  
          {#each navigationData as faqItem}
            <li>
              <Link href={href}>
                  <FeatherIcon icon={faqItem.icon} />{faqItem.name}
              </Link>
              {#if faqItem.badge}
                  <Badge pill class="$bg-primary pull-right" color="primary">{faqItem.badge}</Badge>
              {/if}
            </li>
          {/each}
        </ul>
        <ul >
          <li>
            <Link href={href}><FeatherIcon icon="message-circle" />{'Ask our community'}</Link>
          </li>
          <li>
            <Link href={href}><FeatherIcon icon="mail" />{'Contact us'}</Link>
          </li> 
        </ul>
      </div>
    </div>
  </Card>
</Col>